import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  row: {
    [theme.breakpoints.up('md')]: {
      '& > td': {
        borderTop: `2px solid ${alpha(theme.palette.divider, 0.1)}`,
        borderBottom: `2px solid ${alpha(theme.palette.divider, 0.1)}`,

        '&:first-of-type': {
          borderLeft: `2px solid ${alpha(theme.palette.divider, 0.1)}`,
        },

        '&:last-of-type': {
          borderRight: `2px solid ${alpha(theme.palette.divider, 0.1)}`,
        },
      },
    },

    [theme.breakpoints.down('md')]: {
      border: `2px solid ${alpha(theme.palette.divider, 0.1)}`,
    },
  },

  poolCell: {
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(4),
    },
  },

  commonMdCell: {
    [theme.breakpoints.down('md')]: {
      ':not(:last-of-type)': {
        borderBottom: `2px solid ${alpha(theme.palette.divider, 0.05)}`,
        paddingBottom: theme.spacing(2),
      },
    },
  },
  actions: {
    paddingTop: theme.spacing(4),
  },
}));
